<template>
	<el-dialog :visible.sync="showdialog" :title="title" :width="width" :append-to-body="true" 
	 :close-on-click-modal="false" :destroy-on-close="true">
		<div :style="{'margin-top':'-40px','height':height}">
			<allcontrol v-if="item.l_pagetype!=''"
			 :ref="'dialogcontrol_'+item.l_id" :item="item" :urlparam="urlparam" 
			 @allcontrol="allcontrol"></allcontrol>
		</div>
		<el-row>
			<el-col :span="11" style="color:transparent">1</el-col>
			<el-col :span="8">
				<el-button type="success" size="mini" @click="dialogsrue">{{$lang.label.public.sure}}</el-button>
				<el-button size="mini" @click="dialogclose" style="margin-left:10px">{{$lang.label.public.cancel}}</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {
		allcontrol:() => import("@/pages/main/controlcenter.vue") //组件嵌套需要这样引用才可以，不然会报组件注册错误
	},
	props: {
		
	},
	data(){
		return{
			showdialog:false,
			width: (window.innerWidth*75/100)+'px',
			height:'500px',
			item:{
				l_pagetype:''
			},
			urlparam:{},
			title:'',
			callbackparam:{}
		}
	},
	methods:{
		init(param){
			debugger
			this.showdialog=true;
			this.item=param.item;
			if(param.title!=undefined)
				this.title=param.title;
			if(param.urlparam!=undefined)
				this.urlparam=param.urlparam;
			if(param.height!=undefined)
				this.height=param.height;
			if(param.callbackparam!=undefined)
				this.callbackparam=param.callbackparam;
			
		},
		dialogsrue(){
			//debugger
			var control='';
			var selectedall=this.$refs["dialogcontrol_"+this.item.l_id].$children[0].selectedall;
			if(selectedall==undefined)
			{
				selectedall=this.$refs["dialogcontrol_"+this.item.l_id].$children[0].$children[0].$children[0].selectedall;
				control=this.$refs["dialogcontrol_"+this.item.l_id].$children[0].$children[0].$children[0];
				
			}
			else
				control=this.$refs["dialogcontrol_"+this.item.l_id].$children[0];
				
			if(selectedall){
				//var search=this.$refs["dialogcontrol_"+this.item.l_id].$children[0].$children[0].$children[0].GetSearchObj();
				var rows=control.gridlist;
				this.$emit('dialogsrue', {rows:rows,l_id:this.item.l_id,callbackparam:this.callbackparam});
				
				control.resetfiltercb();
				
				this.showdialog=false;
			}else{
				var rows=control.checkedrow;
				if(rows==undefined)
					rows=control.checkedrow;
				if(rows.length>0)
				{
					this.$emit('dialogsrue', {rows:rows,l_id:this.item.l_id,callbackparam:this.callbackparam});
					control.resetfiltercb();
					this.showdialog=false;
				}
				else
					this.$tool.message(this.$lang.label.gridcol.selempty);
			}
		},
		dialogclose(){
			this.showdialog=false;
		},
		allcontrol(){
			
		}
	},
	destoryed(){
		debugger
	}
}
</script>

<style>
</style>